export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE' // todo: deprecate
export const FLASH_ERROR = 'FLASH_ERROR'
export const FLASH_WARNING = 'FLASH_WARNING'
